import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import partnerReducer from './partnerSlice';
import bookingReducer from './bookingSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    partner: partnerReducer,
    booking: bookingReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
